import { getWord } from "./translator";

const validate = (form: HTMLFormElement | null | undefined): boolean => {
  if (form) {
    const actualForm = document.getElementById(form.$.props.id) as HTMLFormElement;
    const elements = actualForm.elements;
    let isValid = true

    const emptyFields: any[] = []

    if (elements) {
      for (let i = 0; i < elements.length; i++) {
        if (!isValid) {
          emptyFields.push(elements[i - 1].getAttribute('id'))
        }

        isValid = true;
        let element: HTMLInputElement | HTMLSelectElement = elements.item(i) as HTMLInputElement
        if (!element) {
          element = elements[i] as HTMLSelectElement
        }

        if (element) {
          const value = element.value

          const attrValue = element.getAttribute("is-required")?.toLowerCase();
          if (attrValue && JSON.parse(attrValue)) {
            isValid = !!value;
          }

          if (element instanceof HTMLSelectElement) {
            if (!value || value.toLowerCase() === "select") {
              isValid = false;
            }
          }
          else {
            let isNumeric = false;
            if (isValid) {
              const typeAttr = element.getAttribute("type") || "";
              const isOriginalPassword = (element.getAttribute("data-is-password-field") || "").toLowerCase() === "true";
              const effectiveType = isOriginalPassword ? "password" : typeAttr.toLowerCase();

              if (effectiveType.toLowerCase() === "number") {
                if (!value) {
                  return false;
                }

                isNumeric = !isNaN(parseInt(value));
                isValid = isNumeric;
              } 
              else if (effectiveType.toLowerCase() === "email") {
                if (!value) {
                  return false;
                }

                const splitedValue = value.split("@");
                isValid = splitedValue && !!splitedValue[0] && !!splitedValue[1];
              } 
              else if (effectiveType.toLowerCase() === "password") {
                if (!value) {
                  return false;
                }

                const skipValidation = element.getAttribute("data-skip-validation");
                if (skipValidation && skipValidation.toLocaleLowerCase() === "true") {
                  isValid = true;
                } 
                else {
                  const errors = checkPasswordSecurityLevel(value);
                  if (errors && errors.length > 0) {
                    isValid = false;
                  }
                }
              }
            }

            if (isValid) {
              if (isNumeric) {
                const maxValue = element.getAttribute("max");
                if (maxValue && parseInt(maxValue) > -1 && value) {
                  isValid = parseInt(maxValue) < parseInt(value);
                }

                const minValue = element.getAttribute("min");
                if (minValue && parseInt(minValue) > -1 && value && isValid) {
                  isValid = parseInt(minValue) > parseInt(value);
                }
              }
              else {
                const maxLength = element.getAttribute("max-length");
                if (maxLength && parseInt(maxLength) > -1 && value) {
                  isValid = parseInt(maxLength) < value.length
                }

                const minLength = element.getAttribute("min-length");
                if (minLength && parseInt(minLength) > -1 && value && isValid) {
                  isValid = parseInt(minLength) > value.length
                }
              }
            }
          }
        }
      }
    }

    emptyFields.forEach(emptyField => {
      if (emptyField) {
        addDanger(emptyField)
      }
    });

    return isValid
  }
  return false;
}

const addDanger = (elemId: string) => {
  const elem = document.getElementById(elemId)
  if (elem) {
    if (elem instanceof HTMLInputElement) {
      addInputDanger(elem);
    }
    else {
      addSelectDanger(elem);
    }
  }
}

const addInputDanger = (elem: HTMLInputElement) => {
  elem.classList.add("border-danger")
  if (elem.parentElement) {
    elem.parentElement.children.item(0)?.classList.add("text-danger")
  }
  elem.addEventListener("input", function () {
    elem.classList.remove("border-danger")
    if (elem.parentElement) {
      elem.parentElement.children.item(0)?.classList.remove("text-danger")
    }
  })
}

const addSelectDanger = (elem: HTMLElement) => {
  if (elem && elem.children.item(0)) {
    (elem.children.item(0) as HTMLElement).classList.add('border-danger')
  }
  elem.addEventListener("click", function () {
    if (elem && elem.children.item(0)) {
      (elem.children.item(0) as HTMLElement).classList.remove('border-danger')
      // elem.parentElement.children.item(0)?.classList.remove("text-danger")
    }
  })
}

const serilalize = (form: HTMLFormElement | null, desiredProps: string[]) => {
  if (form) {
    const actualForm = document.getElementById(form.$.props.id) as HTMLFormElement;
    const elements = actualForm.elements;

    let i, j;
    const q: any = {}
    for (i = elements.length - 1; i >= 0; i--) {
      let element: HTMLInputElement | HTMLSelectElement = elements[i] as HTMLInputElement
      if (!element) {
        element = elements[i] as HTMLSelectElement
      }
      if (!element) {
        element = elements[i] as any
      }

      let elemName = element.name
      if (!elemName) elemName = element.getAttribute('id') as string
      const isPropDesired = desiredProps?.filter(p => p === elemName) && desiredProps?.filter(p => p === elemName).length > 0

      if (!element || elemName === "" || !isPropDesired) {
        continue;
      }

      const nodeName = element.nodeName.toLowerCase();
      const elemType = element.type.toLowerCase();
      let options;
      let value = element.value;

      switch (nodeName) {
        case 'input':
          switch (elemType) {
            case 'text':
            case 'hidden':
            case 'password':
            case 'button':
            case 'reset':
            case 'submit':
            case 'date':
              q[elemName] = value;
              break;
            case 'checkbox':
            case 'radio':
              if ((element as any).checked) {
                q[elemName] = true;
              }
              break;
          }
          break;
        case 'file':
          q[elemName] = (document.getElementById("packageFile") as any).files[0]
          break;
        case 'textarea':
          q[elemName] = value;
          break;
        case 'select':
          switch (elemType) {
            case 'select-one':
              if (value && value.toLowerCase() !== 'select') {
                q[elemName] = value;
              }
              break;
            case 'select-multiple':
              options = (element as HTMLSelectElement).options
              for (j = options.length - 1; j >= 0; j--) {
                if (options[j].selected) {
                  value = options[j].value;
                  if (value && value.toLowerCase() !== 'select') {
                    q[elemName] = value;
                  }
                }
              }
              break;
          }
          break;
        case 'button':
          switch (elemType) {
            case 'reset':
            case 'submit':
            case 'button':
              q[elemName] = value;
              break;
          }
          break;
      }
    }
    return q
  }
  return null;
}

const clearForm = (formClass: string | null = null) => {
  let form;
  if (formClass)
    form = document.getElementsByClassName(formClass)[0]
  else
    form = document.getElementsByTagName('form')[0]

  if (form) {
    form.reset()
    const clearSelectElems = document.getElementsByClassName('multiselect-clear')
    if (clearSelectElems) {
      const clickEvent = new Event('click')
      for (let i = 0; i < clearSelectElems.length; i++) {
        clearSelectElems.item(i)!.dispatchEvent(clickEvent)
      }
    }
  }
}

const clearAllSelections = () => {
  clearSelections(document.getElementsByClassName('multiselect-clear'))
}

const clearSelection = (id: string) => {
  const elem = document.getElementById(id)
  if (elem) {
    clearSelections(elem.getElementsByClassName('multiselect-clear'))
  }
}

const clearSelections = (clearSelectElems: HTMLCollectionOf<Element>) => {
  if (clearSelectElems) {
    const clickEvent = new Event('click')
    for (let i = 0; i < clearSelectElems.length; i++) {
      clearSelectElems.item(i)!.dispatchEvent(clickEvent)
    }
  }
}

const checkPasswordSecurityLevel = (value: string) => {
  const errors: string[] = [];

  if (!value)
    errors.push(getWord("PasswordCannotBeBlank"));

  const numberRegex = new RegExp("[0-9]+");
  if (!numberRegex.test(value))
    errors.push(getWord("PasswordDoesNotContainNumber"));

  const upperCharRegex = new RegExp("[A-Z]+");
  if (!upperCharRegex.test(value))
    errors.push(getWord("PasswordDoesNotContainUpperChar"));

  const lowerCharRegex = new RegExp("[a-z]+");
  if (!lowerCharRegex.test(value))
    errors.push(getWord("PasswordDoesNotContainLowerChar"));

  const minimum8CharsRegex = new RegExp(".{8,16}");
  if (!minimum8CharsRegex.test(value))
    errors.push(getWord("PasswordMustAtLeast8CharsAtMost16Chars"));

  const specialCharsRegex = new RegExp("[^a-zA-Z0-9ŞşĞğÜüÖöÇçİı]");
  if (!specialCharsRegex.test(value))
    errors.push(getWord("PasswordDoesNotContainSpecialChar"));

  return errors;
}

export { validate, serilalize, clearForm, clearAllSelections, clearSelection, addDanger, checkPasswordSecurityLevel }